"use client";
import moment from "moment-timezone";
import Image from "next/image";

type GameDetailsType = {
    date: Date|null
    venue?: string|null,
    tournamentImage: string|null
    tournamentImageAlt?: string
    showDay?: boolean
    showTime?: boolean
}

export default function GameDetails({date, venue, tournamentImage, tournamentImageAlt, showDay = true, showTime = true}: GameDetailsType) {
    const dateObj = moment(date);
    return (
        <div className="game-details">
            {date &&
              <div className="details-when">
              {showDay &&
                <span className="day">{dateObj.format('dddd')}</span>
              }
                <span className="date">{dateObj.format('D/M')}</span>
              {showTime &&
                <span className="time">{dateObj.format('h:mm A')}</span>
              }
                <span className="zone">{dateObj.format('z')}</span>
              </div>
            }
            <div className="details-where">
                  {venue && venue?.length > 0 &&
                    <span className="venue">{venue}</span>
                  }
                  {tournamentImage && tournamentImage?.length > 0 &&
                    <Image src={tournamentImage ?? ''} alt={tournamentImageAlt ?? 'Logo'} width={24} height={24} />
                  }
            </div>
        </div>
    )
}
